<div class="tableau-wrapper">
  @if (vizUrl && token) {
    <tableau-viz
      [id]="VizIndex"
      [attr.src]="vizUrl"
      [attr.token]="token"
      [attr.toolbar]="toolbar"
    >
    </tableau-viz>
  }
</div>
